import { useEffect } from 'react'
import { sessionStore } from '@features/auth/services/sessionStore'
import { preferencesStore } from '../services/preferencesStore'

/**
 * sessionStore の状態を監視し、preferencesStore のライフサイクルを駆動する (Track D)。
 *
 *   - UNLOCKED 遷移 (= login / unlock 成功): `loadInitial()` で cache → API を fetch
 *   - UNAUTH 遷移 (= logout / clear): `clear()` で in-memory + IndexedDB を破棄
 *
 * App.tsx ルート級で 1 回だけ呼ぶ想定。複数 mount しても loadInitial / clear は
 * idempotent なので安全だが、無駄な fetch を避けるため最上位に置く。
 */
export const usePreferencesSync = (): void => {
  useEffect(() => {
    // 既に authenticated な状態で App が mount された場合は即座に load
    if (sessionStore.isAuthenticated()) {
      void preferencesStore.loadInitial()
    }

    let wasAuthenticated = sessionStore.isAuthenticated()

    return sessionStore.subscribe(() => {
      const isAuthenticated = sessionStore.isAuthenticated()
      if (isAuthenticated && !wasAuthenticated) {
        void preferencesStore.loadInitial()
      } else if (!isAuthenticated && wasAuthenticated) {
        void preferencesStore.clear()
      }
      wasAuthenticated = isAuthenticated
    })
  }, [])
}
